// Generated by purs version 0.15.15
import * as Affjax from "../Affjax/index.js";
import * as Affjax_RequestBody from "../Affjax.RequestBody/index.js";
import * as Affjax_RequestHeader from "../Affjax.RequestHeader/index.js";
import * as Affjax_ResponseFormat from "../Affjax.ResponseFormat/index.js";
import * as Affjax_StatusCode from "../Affjax.StatusCode/index.js";
import * as Affjax_Web from "../Affjax.Web/index.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Error_Class from "../Control.Monad.Error.Class/index.js";
import * as Control_Monad_Except from "../Control.Monad.Except/index.js";
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Data_Bifunctor from "../Data.Bifunctor/index.js";
import * as Data_Boolean from "../Data.Boolean/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_HTTP_Method from "../Data.HTTP.Method/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_List from "../Data.List/index.js";
import * as Data_List_NonEmpty from "../Data.List.NonEmpty/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_MediaType_Common from "../Data.MediaType.Common/index.js";
import * as Data_OneOf from "../Data.OneOf/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Data_String_Common from "../Data.String.Common/index.js";
import * as Data_Traversable from "../Data.Traversable/index.js";
import * as Data_Unfoldable from "../Data.Unfoldable/index.js";
import * as Effect_Aff from "../Effect.Aff/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic from "../Foreign.Generic/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Foreign_Index from "../Foreign.Index/index.js";
import * as Network_RPCError from "../Network.RPCError/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
import * as Unscramble from "../Unscramble/index.js";
var show = /* #__PURE__ */ Data_Show.show(Affjax_StatusCode.showStatusCode);
var show1 = /* #__PURE__ */ Data_Show.show(Network_RPCError.showRpcError);
var lmap = /* #__PURE__ */ Data_Bifunctor.lmap(Data_Bifunctor.bifunctorEither);
var genericShowConstructor = /* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Data_Show.showString));
var DecodingErrorIsSymbol = {
    reflectSymbol: function () {
        return "DecodingError";
    }
};
var eq = /* #__PURE__ */ Data_Eq.eq(Affjax_StatusCode.eqStatusCode);
var eq2 = /* #__PURE__ */ Data_Eq.eq(Network_RPCError.eqRPCError);
var genericEncodeConstructor = /* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
    reflectSymbol: function () {
        return "Request";
    }
});
var encodeWithOptionsRecord = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord();
var encodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons();
var encodeRecordCons1 = /* #__PURE__ */ encodeRecordCons(Foreign_Generic_Class.encodeRecordNil)({
    reflectSymbol: function () {
        return "params";
    }
});
var methodIsSymbol = {
    reflectSymbol: function () {
        return "method";
    }
};
var encodeWithOptionsOther = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode);
var idIsSymbol = {
    reflectSymbol: function () {
        return "id";
    }
};
var bind = /* #__PURE__ */ Control_Bind.bind(/* #__PURE__ */ Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity));
var ix = /* #__PURE__ */ Foreign_Index.ix(/* #__PURE__ */ Foreign_Index.indexableForeign(Data_Identity.monadIdentity))(/* #__PURE__ */ Foreign_Index.indexString(Data_Identity.monadIdentity));
var readString = /* #__PURE__ */ Foreign.readString(Data_Identity.monadIdentity);
var readNullOrUndefined = /* #__PURE__ */ Foreign.readNullOrUndefined(Data_Identity.monadIdentity);
var applicativeExceptT = /* #__PURE__ */ Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity);
var traverse = /* #__PURE__ */ Data_Traversable.traverse(Data_Traversable.traversableMaybe)(applicativeExceptT);
var decode = /* #__PURE__ */ Foreign_Generic_Class.decode(Network_RPCError.decodeRPCError);
var pure = /* #__PURE__ */ Control_Applicative.pure(applicativeExceptT);
var pure1 = /* #__PURE__ */ Control_Applicative.pure(/* #__PURE__ */ Control_Monad_Except_Trans.applicativeExceptT(Effect_Aff.monadAff));
var throwError = /* #__PURE__ */ Control_Monad_Error_Class.throwError(/* #__PURE__ */ Control_Monad_Except_Trans.monadThrowExceptT(Effect_Aff.monadAff));
var inj = /* #__PURE__ */ Data_OneOf.inj()(DecodingErrorIsSymbol);
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var show2 = /* #__PURE__ */ Data_Show.show(Foreign.showForeignError);
var toUnfoldable = /* #__PURE__ */ Data_List.toUnfoldable(Data_Unfoldable.unfoldableArray);
var append1 = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var map1 = /* #__PURE__ */ Data_Functor.map(Effect_Aff.functorAff);
var Success = /* #__PURE__ */ (function () {
    function Success(value0) {
        this.value0 = value0;
    };
    Success.create = function (value0) {
        return new Success(value0);
    };
    return Success;
})();
var RPCFailure = /* #__PURE__ */ (function () {
    function RPCFailure(value0) {
        this.value0 = value0;
    };
    RPCFailure.create = function (value0) {
        return new RPCFailure(value0);
    };
    return RPCFailure;
})();
var Request = function (x) {
    return x;
};
var UnexpectedStatus = /* #__PURE__ */ (function () {
    function UnexpectedStatus(value0) {
        this.value0 = value0;
    };
    UnexpectedStatus.create = function (value0) {
        return new UnexpectedStatus(value0);
    };
    return UnexpectedStatus;
})();
var NetworkError = /* #__PURE__ */ (function () {
    function NetworkError(value0) {
        this.value0 = value0;
    };
    NetworkError.create = function (value0) {
        return new NetworkError(value0);
    };
    return NetworkError;
})();
var DecodingError = /* #__PURE__ */ (function () {
    function DecodingError(value0) {
        this.value0 = value0;
    };
    DecodingError.create = function (value0) {
        return new DecodingError(value0);
    };
    return DecodingError;
})();
var RPCError = /* #__PURE__ */ (function () {
    function RPCError(value0) {
        this.value0 = value0;
    };
    RPCError.create = function (value0) {
        return new RPCError(value0);
    };
    return RPCError;
})();
var aPIUrlSites = {
    apiUrl: function (v) {
        return "/api/v1/sites/rpc";
    }
};
var aPIUrlROS = {
    apiUrl: function (v) {
        return "/api/v1/ros/rpc";
    }
};
var aPIUrlPortal = {
    apiUrl: function (v) {
        return "/api/v1/portal/rpc";
    }
};
var aPIUrlPR = {
    apiUrl: function (v) {
        return "/api/v1/pr/rpc";
    }
};
var aPIUrlInternal = {
    apiUrl: function (v) {
        return "/api/v1/internal/rpc";
    }
};
var aPIUrlHQ = {
    apiUrl: function (v) {
        return "/api/v1/hq/rpc";
    }
};
var rpcMethodName = function (dict) {
    return dict.rpcMethodName;
};
var rpc$prime = function (dictRPCMethodName) {
    var rpcMethodName1 = rpcMethodName(dictRPCMethodName);
    return function (dictMonad) {
        var bind1 = Control_Bind.bind(dictMonad.Bind1());
        var pure2 = Control_Applicative.pure(dictMonad.Applicative0());
        return function (run) {
            return function (req) {
                var req$prime = {
                    id: "1",
                    method: rpcMethodName1(Type_Proxy["Proxy"].value),
                    params: req
                };
                return bind1(run(req$prime))(function (res) {
                    return pure2((function () {
                        if (res instanceof Data_Either.Right && res.value0 instanceof Success) {
                            return new Data_Either.Right(res.value0.value0.result);
                        };
                        if (res instanceof Data_Either.Right && res.value0 instanceof RPCFailure) {
                            return new Data_Either.Left(new RPCError(res.value0.value0.error));
                        };
                        if (res instanceof Data_Either.Left) {
                            return new Data_Either.Left(res.value0);
                        };
                        throw new Error("Failed pattern match at Network.JsonRPC (line 100, column 10 - line 103, column 29): " + [ res.constructor.name ]);
                    })());
                });
            };
        };
    };
};
var remoteErrorToString = function (v) {
    if (v instanceof UnexpectedStatus) {
        return "UnexpectedStatus: " + show(v.value0);
    };
    if (v instanceof NetworkError) {
        return "NetworkError: " + v.value0;
    };
    if (v instanceof DecodingError) {
        return "DecodingError: " + v.value0;
    };
    if (v instanceof RPCError) {
        return "RPCError: " + show1(v.value0);
    };
    throw new Error("Failed pattern match at Network.JsonRPC (line 90, column 3 - line 94, column 45): " + [ v.constructor.name ]);
};
var rpc = function (dictRPCMethodName) {
    var rpc$prime1 = rpc$prime(dictRPCMethodName);
    return function (dictMonad) {
        var map2 = Data_Functor.map(((dictMonad.Bind1()).Apply0()).Functor0());
        var rpc$prime2 = rpc$prime1(dictMonad);
        return function (run) {
            var $207 = map2(lmap(remoteErrorToString));
            var $208 = rpc$prime2(run);
            return function ($209) {
                return $207($208($209));
            };
        };
    };
};
var newtypeRequest = {
    Coercible0: function () {
        return undefined;
    }
};
var genericResponse = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new Success(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr) {
            return new RPCFailure(x.value0);
        };
        throw new Error("Failed pattern match at Network.JsonRPC (line 44, column 1 - line 44, column 58): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof Success) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof RPCFailure) {
            return new Data_Generic_Rep.Inr(x.value0);
        };
        throw new Error("Failed pattern match at Network.JsonRPC (line 44, column 1 - line 44, column 58): " + [ x.constructor.name ]);
    }
};
var genericRequest = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var defaultEncode = /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericRequest);
var genericRemoteError = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new UnexpectedStatus(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return new NetworkError(x.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return new DecodingError(x.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inr)) {
            return new RPCError(x.value0.value0.value0);
        };
        throw new Error("Failed pattern match at Network.JsonRPC (line 77, column 1 - line 77, column 60): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof UnexpectedStatus) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof NetworkError) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
        };
        if (x instanceof DecodingError) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)));
        };
        if (x instanceof RPCError) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0)));
        };
        throw new Error("Failed pattern match at Network.JsonRPC (line 77, column 1 - line 77, column 60): " + [ x.constructor.name ]);
    }
};
var showRemoteError = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericRemoteError)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Affjax_StatusCode.showStatusCode))({
        reflectSymbol: function () {
            return "UnexpectedStatus";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
        reflectSymbol: function () {
            return "NetworkError";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(DecodingErrorIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Network_RPCError.showRpcError))({
        reflectSymbol: function () {
            return "RPCError";
        }
    })))))
};
var errorUnexpectedStatus = /* #__PURE__ */ (function () {
    return UnexpectedStatus.create;
})();
var eqRemoteError = {
    eq: function (x) {
        return function (y) {
            if (x instanceof UnexpectedStatus && y instanceof UnexpectedStatus) {
                return eq(x.value0)(y.value0);
            };
            if (x instanceof NetworkError && y instanceof NetworkError) {
                return x.value0 === y.value0;
            };
            if (x instanceof DecodingError && y instanceof DecodingError) {
                return x.value0 === y.value0;
            };
            if (x instanceof RPCError && y instanceof RPCError) {
                return eq2(x.value0)(y.value0);
            };
            return false;
        };
    }
};
var encodeRequest = function (dictEncode) {
    return function (dictEncodeWithOptions) {
        return {
            encode: defaultEncode(genericEncodeConstructor(Foreign_Generic_Class.genericEncodeArgsRecord(encodeWithOptionsRecord(encodeRecordCons(encodeRecordCons(encodeRecordCons1(dictEncodeWithOptions))(methodIsSymbol)(encodeWithOptionsOther))(idIsSymbol)(encodeWithOptionsOther)))))
        };
    };
};
var decodeResponse = function (dictDecode) {
    var decode1 = Foreign_Generic_Class.decode(dictDecode);
    return {
        decode: function (value) {
            return bind(bind(ix(value)("id"))(readString))(function (id) {
                return bind(bind(bind(ix(value)("error"))(readNullOrUndefined))(traverse(decode)))(function (mError) {
                    if (mError instanceof Data_Maybe.Just) {
                        return pure(new RPCFailure({
                            id: id,
                            error: mError.value0
                        }));
                    };
                    if (mError instanceof Data_Maybe.Nothing) {
                        return bind(bind(ix(value)("result"))(decode1))(function (result) {
                            return pure(new Success({
                                id: id,
                                result: result
                            }));
                        });
                    };
                    throw new Error("Failed pattern match at Network.JsonRPC (line 53, column 5 - line 57, column 50): " + [ mError.constructor.name ]);
                });
            });
        }
    };
};
var decodeJSONU = function (dictDecode) {
    var decodeJSONEither = Unscramble.decodeJSONEither(dictDecode);
    return function (json) {
        var v = decodeJSONEither(json);
        if (v instanceof Data_Either.Right) {
            return pure1(v.value0);
        };
        if (v instanceof Data_Either.Left) {
            return throwError(inj(Type_Proxy["Proxy"].value)(v.value0));
        };
        throw new Error("Failed pattern match at Network.JsonRPC (line 163, column 3 - line 165, column 76): " + [ v.constructor.name ]);
    };
};
var decodeJSONE = function (dictDecode) {
    var decodeJSON = Foreign_Generic.decodeJSON(dictDecode);
    return function (json) {
        var v = Control_Monad_Except.runExcept(decodeJSON(json));
        if (v instanceof Data_Either.Right) {
            return pure1(v.value0);
        };
        if (v instanceof Data_Either.Left) {
            return throwError(inj(Type_Proxy["Proxy"].value)(Data_String_Common.joinWith("\x0a")(map(show2)(toUnfoldable(Data_List_NonEmpty.toList(v.value0))))));
        };
        throw new Error("Failed pattern match at Network.JsonRPC (line 157, column 3 - line 159, column 147): " + [ v.constructor.name ]);
    };
};
var decodeJSON$prime = function (dictDecode) {
    var decodeJSON = Foreign_Generic.decodeJSON(dictDecode);
    return function (json) {
        var v = Control_Monad_Except.runExcept(decodeJSON(json));
        if (v instanceof Data_Either.Right) {
            return new Data_Either.Right(v.value0);
        };
        if (v instanceof Data_Either.Left) {
            return new Data_Either.Left(new DecodingError(Data_String_Common.joinWith("\x0a")(map(show2)(toUnfoldable(Data_List_NonEmpty.toList(v.value0))))));
        };
        throw new Error("Failed pattern match at Network.JsonRPC (line 151, column 3 - line 153, column 110): " + [ v.constructor.name ]);
    };
};
var runAffjax = function (dictEncode) {
    var encodeJSON = Foreign_Generic.encodeJSON(dictEncode);
    return function (dictDecode) {
        var decodeJSON$prime1 = decodeJSON$prime(dictDecode);
        return function (dictRPCMethodName) {
            var rpcMethodName1 = rpcMethodName(dictRPCMethodName);
            return function (api) {
                return function (authHeaders) {
                    return function (request) {
                        var rpcMethodName$prime = rpcMethodName1(Type_Proxy["Proxy"].value);
                        var handleResponse = function (v) {
                            if (v instanceof Data_Either.Left) {
                                return new Data_Either.Left(new NetworkError(Affjax.printError(v.value0)));
                            };
                            if (v instanceof Data_Either.Right) {
                                if (eq(v.value0.status)(200)) {
                                    return decodeJSON$prime1(v.value0.body);
                                };
                                if (Data_Boolean.otherwise) {
                                    return new Data_Either.Left(errorUnexpectedStatus(v.value0.status));
                                };
                            };
                            throw new Error("Failed pattern match at Network.JsonRPC (line 134, column 3 - line 134, column 74): " + [ v.constructor.name ]);
                        };
                        var api$prime = api + ("?" + rpcMethodName$prime);
                        var request$prime = {
                            username: Affjax.defaultRequest.username,
                            password: Affjax.defaultRequest.password,
                            withCredentials: Affjax.defaultRequest.withCredentials,
                            timeout: Affjax.defaultRequest.timeout,
                            url: api$prime,
                            headers: append1(authHeaders)([ new Affjax_RequestHeader.ContentType(Data_MediaType_Common.applicationJSON) ]),
                            method: new Data_Either.Left(Data_HTTP_Method.POST.value),
                            content: new Data_Maybe.Just(new Affjax_RequestBody["String"](encodeJSON(request))),
                            responseFormat: Affjax_ResponseFormat.string
                        };
                        return map1(handleResponse)(Affjax_Web.request(request$prime));
                    };
                };
            };
        };
    };
};
var apiUrl = function (dict) {
    return dict.apiUrl;
};
export {
    apiUrl,
    rpcMethodName,
    Request,
    Success,
    RPCFailure,
    UnexpectedStatus,
    NetworkError,
    DecodingError,
    RPCError,
    rpc,
    remoteErrorToString,
    rpc$prime,
    errorUnexpectedStatus,
    runAffjax,
    decodeJSON$prime,
    decodeJSONE,
    decodeJSONU,
    newtypeRequest,
    genericRequest,
    genericResponse,
    encodeRequest,
    decodeResponse,
    genericRemoteError,
    eqRemoteError,
    showRemoteError,
    aPIUrlPR,
    aPIUrlROS,
    aPIUrlSites,
    aPIUrlHQ,
    aPIUrlInternal,
    aPIUrlPortal
};
